import { render } from "./MerchantPurchaseStock.vue?vue&type=template&id=02b8840f&scoped=true"
import script from "./MerchantPurchaseStock.vue?vue&type=script&lang=js"
export * from "./MerchantPurchaseStock.vue?vue&type=script&lang=js"

import "./MerchantPurchaseStock.vue?vue&type=style&index=0&id=02b8840f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b8840f"]])

export default __exports__